type SummaryDetailLabelProps = {
  label: string;
};

export const SummaryDetailLabel: React.FC<SummaryDetailLabelProps> = ({ label }) => {
  return (
    <div className="absolute top-0 left-5 flex -translate-y-1/2 items-center justify-center">
      <div className="absolute top-1/2 z-10 h-0.5 w-[calc(100%+12px)] -translate-y-1/2 bg-white" />
      <span className="z-20 text-xs font-bold">{label}</span>
    </div>
  );
};
